import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { KkmSettingsNavigationService } from '../services/kkm-setting-navigation.service';

@Component({
  selector: 'tax-kkm-settings-buttons-control',
  templateUrl: './kkm-settings-buttons-control.component.html',
  styleUrls: ['./kkm-settings-buttons-control.component.sass'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
  ],
})

export class KkmSettingsButtonsControlComponent {
  @Input() isDisable = true;
  @Output() changeKkmData = new EventEmitter<void>();
  constructor(private kkmSettingsNavigationService: KkmSettingsNavigationService) {}

  back(): void {
    this.kkmSettingsNavigationService.goToBack();
  }

  saveKkmData(): void {
    this.changeKkmData.emit();
  }
}
